import { useServices } from "./useServices.js";
const useFileCache = ()=>useServices().fileCache;
export { useFileCache };
